import React, { Component } from 'react';
import moment from 'moment';
import Loading from '../../ui/Loading';
import { handleCookieNav } from '../../ui/CookieLink';

const REACT_APP_CHECKOUT_LINK = `${process.env.REACT_APP_CHECKOUT_LINK}`;

class Active extends Component {
  constructor(props) {
    super(props);
    this.state = { loadedClubInfo: false }
  }


  render() {
    const {
      user,
      clubResult,
      clubByIdInProgress,
      clubError,
      showModal,
      waitlist,
      joinWaitListResult,
      waitListStatusInProgress,
      acceptInvitationResult,
      getCartInProgress,
      switchClubMembership,
      deleteWaitlist,
      clearGetClubById
    } = this.props;

    const { ClubMember } = user || {};
    const {
      ClubName,
      inWaitList,
      waitList,
    } = clubResult || {};

    const {
      waitListClubName,
      InviteSentDate,
      expired,
    } = waitList || {};

    const {
      ShippingAddressId,
      ClubName:currentClubName
    } = ClubMember || {};


    return (
 
      <>
        {
          (clubByIdInProgress ||
          waitListStatusInProgress ||
          getCartInProgress ||
          !user
          ) ?
            <Loading /> :
          <>
            { clubError ?
              <p className="account-info-block">
                {clubError.message || ''}
              </p>
              :
              <>
               <p className="account-info-block">
                 {
                  joinWaitListResult ?
                  `Thank you for joining the ${ClubName} membership waitlist, we will be in touch…`
                  :
                  inWaitList ?
                    expired === 1 ?
                    `We have been waiting to hear from you. Looks like we sent an invite on
                    ${moment(InviteSentDate).format('MMM DD, YYYY')}, but we never heard back. Unfortunately this
                    invitation expired on ${moment(InviteSentDate).add(15, 'days').format('MMM DD, YYYY')}.
                    If you would like to extend your waitlist period please contact us at (888) 202-2006.`
                    :
                    InviteSentDate ?
                    <>
                        <div className="row justify-content-center" style={{ margin: 'auto' }}>
                    
                            {
                              `Our records show that you already have the ${currentClubName} membership. 
                              Do you wish to switch to the ${ClubName} membership?`
                            }
                        </div>
                        <div className="col-md-8" style={{ marginTop: '1rem', marginBottom: '2rem', marginLeft: '-15px' }}>
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{ marginRight: '0.5rem' }}
                              onClick={ () => {
                                  switchClubMembership(
                                    { clubTypeId: parseInt(waitlist) },
                                    null,
                                    null,
                                    () => {
                                      clearGetClubById();
                                    }
                                  )
                                }
                              }
                            >
                              Continue
                            </button>

                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              style={{ marginRight: '0.5rem' }}
                              onClick={() => {
                                deleteWaitlist(
                                  { clubTypeId: parseInt(waitlist) },
                                  null,
                                  null,
                                  () => {
                                    this.setState({ loadedClubInfo: false });
                                    clearGetClubById();
                                  }
                                )
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </>
                       :
                       `You have been added to the  ${waitListClubName} membership waitlist.
                         We will notify you when an opening becomes available.`
                    :
                      ( ClubName !== waitListClubName && waitlist)?
                        (currentClubName === ClubName   )?
                          `You are already a member of the ${currentClubName} membership and cannot join the selected waitlist.`
                          :
                          `You are already a member of the ${currentClubName} membership,
                           selecting the button below will add you to the ${ClubName} membership waitlist.`
                        :
                        ClubName && waitlist?
                           `Our records show you already have an active waitlist record for 
                             ${waitListClubName}. 
                            Please contact customer support if you would like to be removed from this waitlist.`
                            :
                            ''
                }
                </p>
                  {
                    (!joinWaitListResult && !inWaitList && !waitListClubName && (currentClubName !== ClubName) && ClubName && waitlist) &&
                      <p className="account-info-block">
                        <a href="#" className="btn btn-primary" onClick={() => {
                            showModal('VerifyAddressModal')
                        }}>
                             {`${ClubName} waitlist`}
                        </a>
                      </p>
                   }

              </>
            }
        </>
      }
    </>
    );
  }
}



export default Active
